<template>
  <div class="">
    <figure :class="figstyles">
      <router-link :to="'/gallery/'+hid" class="flex justify-center items-start">
        <img
          :src="
            'https://api.caseyhouse.com/sendyourlove/assets/' +
              hash +
              '?key=thumbnail'
          "
          :data-src="
            'https://api.caseyhouse.com/sendyourlove/assets/' +
              hash +
              '?key=medium'
          "
          :alt="artist"
          :data-content="artist"
          class="mb-6 object-contain"
          width="300"
      /></router-link>
      <figcaption class="absolute" v-if="showName !== false">
        {{ artist!="Anonymous" ? artist : "" }}
      </figcaption>
      
    </figure>
   
  </div>
</template>

<script>
// import mediumZoom from 'medium-zoom'

export default {
  name: "Heart",
  props: [
    "artist",
    "email",
    "hash",
    "src-watermarked",
    "heart",
    "rank",
    "figstyles",
    "showName",
    "hid",
    "index"
  ],
  mounted() {
    // console.log(this.id);
  },
};
</script>

<style scoped>



figcaption {
  bottom: .85rem;
  left: 1.25rem;
}

figure img{
  /* width: 100%; */
  /* height:auto; */
  /* object-fit: contain; */
}

</style>